const googleMapAPIKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY

const googleMapLibraries = ["places", "drawing"]
const versionApp = process.env.REACT_APP_VERSION;
export {
    googleMapAPIKey,
    versionApp,
    googleMapLibraries
}